import { SelectSearchField } from 'components'
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useFormikContext } from 'formik'


const propTypes = {
  name     : PropTypes.string,
  label    : PropTypes.string,
  required : PropTypes.bool
}

const defaultProps = {
  name     : '',
  label    : '',
  required : true
}

/**
 * Search field to select lead source.
 * @param {string} name - Formik field name
 * @param {string} label - Field Label
 * @param {bool} required - It will show required badge if it set `true`
 */
export const salesNameList = [
    {
      label: "Jacqueline - JANE",
      value: "Jacqueline",
    },
    {
      label: "Vanya - VALEN",
      value: "Vanya",
    },
    {
      label: "Debby - MARTHA",
      value: "Debby",
    },
    {
      label: "Cindy - SAM",
      value: "Cindy",
    },
    {
      label: "Sabrina - ZARA",
      value: "Sabrina",
    },
    {
      label: "Amarilis - MARINA",
      value: "Amarilis",
    },
    {
      label: "Angel - KANA",
      value: "Angel",
    },
    {
      label: "Visha - VINA",
      value: "Visha",
    },
    {
      label: "Nisa - RACHEL",
      value: "Nisa",
    },
    {
      label: "Jenni - GINA",
      value: "Jenni",
    },
    {
      label: "Luthfi - LUVI",
      value: "Luthfi",
    },
    {
      label: "Novida - VIVI",
      value: "Novida",
    },
    {
      label: "Elsy - EDITA",
      value: "Elsy",
    },
    {
      label: "Indra - ANDRA",
      value: "Indra",
    },
    {
      label: "Laili - VERA",
      value: "Laili",
    },
    {
      label: "Winny - WINONA",
      value: "Winny",
    },
    {
      label: "Novi - TANIA",
      value: "Novi",
    },
    {
      label: "Celia - ANYA",
      value: "Celia",
    },
    {
      label: "Yasyifa - KIKI",
      value: "Yasyifa",
    },
    {
      label: "Septi - SARAH",
      value: "Septi",
    },
    {
      label: "Mifta - KARLA",
      value: "Mifta",
    },
    {
      label: "Not Available",
      value: "Not_Available",
    },
  ]

const SalesNameSelectSearchField = ({
  name,
  label,
  required,
  userId,
  productIdWithSellingPriceList,
  ...props
}) => {

  const { setFieldError, setFieldTouched, setFieldValue } = useFormikContext()



  const [ filteredSalesNameList, setFilteredSalesNameList ] = useState(salesNameList)
  const [ isSearchLoading, setSearchLoading ] = useState(false)

  // The presentation of option label when dropdown is open
  const getOptionLabel = (option) => (
    option.label
  )
  const getSelectedOptionLabel = (option) => (
    option
  )

  // handler to search
  const handleSelectSearchOnChange = (event) => {
    const searchText = event.target.value
    setFilteredSalesNameByQuery(salesNameList, searchText)
  }
  const setFilteredSalesNameByQuery = (salesNameList, searchText) => {
    if(searchText){
      setFilteredSalesNameList(
        salesNameList.filter(o => o.label.toLowerCase().includes(searchText))
      )
    }else{
      setFilteredSalesNameList(salesNameList)
    }
  }

  return (
    <SelectSearchField
      type='text'
      name={ name }
      label={ label }
      placeholder='Search...'
      dataList={ filteredSalesNameList }
      onSearchChange={ handleSelectSearchOnChange }
      getOptionLabel={ getOptionLabel }
      getSelectedOptionLabel={ getSelectedOptionLabel }
      isLoading={ isSearchLoading }
      required={ required }
      onSelect={(selectedOption) => {
        setFieldValue(name, selectedOption.value)
        setFieldTouched(name, true, false)
      }}
      { ...props }
    />
  )
}

SalesNameSelectSearchField.propTypes    = propTypes
SalesNameSelectSearchField.defaultProps = defaultProps

export default SalesNameSelectSearchField
